// Client-generated download for static text content — no fetch, no pre-hosted
// file. Mirrors the Blob/createObjectURL/synthetic-anchor mechanics of
// hooks/useUrlFileDownload, minus the network round trip.
export const downloadTextFile = (
  content: string,
  filename: string,
  mimeType = 'text/plain'
) => {
  const blob = new Blob([content], { type: mimeType })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
